let news = [
    {
        title: '华方机器人亮相“双创周”。',
        id:1,
        time: '2021-10-22',
        content: '<p>10月19日，以“高质量创新创造，高水平创业就业”为主题的2021年全国大众创业万众创新活动周北京会场主题展(简称“双创周”)在京召开，25日在北京会场正式落下帷幕。</p>' +
            '<div class="news-image"><img src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/%E5%9B%BE%E5%83%8F%20142.png" alt=""></div>' +
            '<p>主题展览设置在中关村国家自主创新示范区展示中心西展区，共计8000平米，展示期为10月19日至10月25日。设置创新创业支撑科技自立自强、创新创业创造高精尖发展新动能、创新创业创造美好新生活、专业平台推动高质量创新创业等四个室内展区，以及一个室外展区，展示210多个创业项目和相关服务机构，以实物、模型、多媒体等形式进行展示。</p>' +
            '<div class="news-image"><img src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/%E5%9B%BE%E5%83%8F%20143.png" alt=""></div>' +
            '<p>华方智能巡检机器人，基于高度集成的人工智能算法，可实现完全代替人工巡检。适用于煤矿、电厂、水泥厂、化工厂等高危场所的长距离输送机智能巡检。机器人搭载多种传感器，实时采集现场的图像、声音、红外热像、烟雾、多种有害气体浓度等参数。机器人具有智能识别功能，采用智能感知关键技术算法，能够准确判断设备当前运行状态，并基于大数据分析预警技术，对各类场所设备运行故障超前预判、预警，减少故障停机时间。</p>'+
            '<div class="news-image"><img src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/%E5%9B%BE%E5%83%8F%20145.png" alt=""></div>',
        imgUrl: 'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/%E5%9B%BE%E5%83%8F%20142.png'
    },
    {
        title: '我司荣获第十届中国创新创业大赛广州赛区总决赛三等奖',
        id:2,
        time: '2021-10-22',
        content: '<p>2021 年7月，第十届中国创新创业大赛（广东·广州赛区）暨第六届羊城“科创杯”创新创业大赛（以下简称 “大赛”）正式召开。</p>' +
            '<p>本届大赛共吸引了2667家广州市科技企业参加，参赛项目包括输送机巡检机器人、超高清影像芯片、声学滤波芯片、SAAS平台、高性能电机驱动控制等方向，其中新一代信息技术行业企业约占40%，参赛企业数量持续领跑大赛六大行业。</p>' +
            '<p>经过层层选拔，65家企业进入初创组半决赛，广州华方智能科技有限公司以第四名的成绩脱颖而出，成功晋级总决赛。</p>' +
            '<p>最终，我司以91.71的分数荣获大赛三等奖！</p>' +
            '<div class="news-image"><img src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/1.jpg" alt=""></div>' +
            '<div class="news-image"><img src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/3.jpg" alt=""></div>' +
            '<p>比赛结束后，现场举行了科技金融精准面对面环节。我司创始人林贺深度参与了会后沟通与洽谈，参会企业与人员包括广州市科学技术局科技金融处副处长麦家星，大湾区科技创新服务中心党支部书记、董事长秦海鸥，广州开发区科技金融服务中心总经理邢宝伟，中国银行广东省分行普惠金融事业部副总经理廖可可，湾创创新投资(广州）有限公司总经理易宇鲲，广州科技金融创新投资控股有限公司投资总监张蕾蕾，广东粤科创业投资管理有限公司投资总监严国良，广州市天河区投资基金管理有限公司总经理朱发军。</p>' +
            '<div class="news-image"><img src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/2.jpg" alt=""></div>',
        imgUrl: 'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/2.jpg'
    },
    {
        title: '华方智能 - 中国创新创业大赛',
        id:3,
        time: '2021-09-03',
        content: '<p>大湾区中心在省市区政府的共同推动下快速发展，先后承办了中国创新创业大赛（广东·广州赛区）、粤港澳大湾区创投50人论坛、广州创投周等重要活动。我司参与了其中的创新创业大赛（广东·广州赛区），并在参加复赛比赛的400多家企业中脱颖而出，荣获(广州赛区)初创组第一名！</p>' +
            '<div class="news-image"><img src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/4ca12ed6a93ceaff3a060ebbc4f714dd6fa574f3ac10dfe1c24dadf960ecb68bQzpcVXNlcnNcYWRtaW5cQXBwRGF0YVxSb2FtaW5nXERpbmdUYWxrXDY2NjAyNjAyOV92MlxJbWFnZUZpbGVzXDEzMTg2NjY5XDQ1NzAzNTAwNTZfNDQ0NjgyMjMzNDFf5pyq5qCH6aKYLTEuanBn.jpg" alt=""></div>',
        imgUrl: 'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/4ca12ed6a93ceaff3a060ebbc4f714dd6fa574f3ac10dfe1c24dadf960ecb68bQzpcVXNlcnNcYWRtaW5cQXBwRGF0YVxSb2FtaW5nXERpbmdUYWxrXDY2NjAyNjAyOV92MlxJbWFnZUZpbGVzXDEzMTg2NjY5XDQ1NzAzNTAwNTZfNDQ0NjgyMjMzNDFf5pyq5qCH6aKYLTEuanBn.jpg'
    },
    {
        title: '华方智能 - 和林电厂机器人巡检项目',
        time: '2021-06-22',
        id:4,
        content: '<p>和林电厂巡检机器人项目，获得集团、分公司领导密集调研！</p>' +
            '<div class="news-image"><img src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/09f8783a960df785219ad05a5f2a664.jpg" alt=""></div>',
        imgUrl: 'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/09f8783a960df785219ad05a5f2a664.jpg'
    },
    {
        title: '华方智能 - UNIFUN团队乔迁大吉',
        time: '2021-02-10',
        id:5,
        content: '<p>1月1日确定办公地点时！这里还是空旷一片，短短十二天，见证奇迹的发生！十二天之内，刷墙、铺地、布线、进家具，一气呵成。这就是unifun团队的速度，没有做不到，只有想不到。创业之路艰辛无比，但拥有一群目标坚定，相互信任的伙伴，为一个共同的目标走到一起，再艰辛也会甘之若饴。多年以后回想起来，有这样一群人一起做着一件有意义、有希望的事业，那这一段的人生就是精彩与值得的！加油！unifun的伙伴们！</p>' +
            '<div class="news-image"><img src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/1634023154716_F6436D52-70BE-4020-9C32-EC6ADCDE9961.png" alt=""></div>',
        imgUrl: 'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/1634023154716_F6436D52-70BE-4020-9C32-EC6ADCDE9961.png'
    },

    {
        title: '华方智能 - 全新「煤安版」智能巡检机器人全部上线',
        time: '2021-07-12',
        id:6,
        content: '<p>最新煤安版机器人整合视觉算法检测技术、音频检测处理技术、热成像识别处理技术、烟雾传感器采集技术、人工智能识别技术等，实现对输煤廊道、输送机场景和设备的全方位全自主智能巡检和实时监控，最新煤安版机器人整合视觉算法检测技术、音频检测处理技术、热成像识别处理技术、烟雾传感器采集技术、人工智能识别技术等，实现对输煤廊道、输送机场景和设备的全方位全自主智能巡检和实时监控，最新煤安版机器人整合视觉算法检测技术、音频检测处理技术、热成像识别处理技术、烟雾传感器采集技术、人工智能识别技术等，实现对输煤廊道、输送机场景和设备的全方位全自主智能巡检和实时监控。</p>' +
            '<div class="news-image"><img src="https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/%E5%9B%BE%E5%83%8F%2016.png" alt=""></div>',
        imgUrl: 'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/news/%E5%9B%BE%E5%83%8F%2016.png'
    }
]

export default {news}